import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppState } from '../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../commons/services/alert.service';
import { Notifications } from '../../../../../commons/models/notifications';
import * as NotificationsActions from '../../../../../store/actions/notifications.actions';


@Component({
    selector: 'app-new-notifications',
    templateUrl: './new-notifications.component.html',
    styleUrls: ['./new-notifications.component.scss']
})
export class NewNotificationsComponent {
    private unsubscribe$ = new Subject<void>();
    notificationsForm: UntypedFormGroup;
    notifications: Notifications;

    constructor(
        private store$: Store<AppState>,
        private alertService: AlertService,
        private fb: UntypedFormBuilder,
        private dialog: MatDialog,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        if(this.data) {
            this.notifications = this.data.notification
        }

        this._createForm();
        this.ngOnChanges();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private _createForm() {
        let notificationsGroup = {
            //sent_at: [""],
            title: ["", Validators.required],
            body: ["", Validators.required],   
        };
    
        this.notificationsForm = this.fb.group(notificationsGroup);
        // console.log('Form creato con i valori:', this.closuresForm.value);
    
    }

    private ngOnChanges() {
        if (this.notificationsForm) {
          this.notificationsForm.reset();
          
          this._initFormValues(this.notifications);
        }
    }

    private _initFormValues(notifications?: Notifications) {
        if (notifications) {
            
            const sentAt = notifications.sent_at ? new Date(notifications.sent_at) : null;
            const tenantId = this.data?.tenant_id ?? null;
    
            this.notificationsForm.patchValue({
                sent_at: sentAt ? notifications.sent_at : null,
                title: notifications.title,
                body: notifications.body,
                tenant_id: tenantId
            });
        } 
        else {
            this.notificationsForm.markAllAsTouched();
        }
    }

    private _prepareSaveNotification(): Notifications {
        let notification = Notifications.fromFormGroup(this.notificationsForm, this.notifications);
        notification.tenant_id = this.data?.tenant_id;

        return notification
    }

    save() {   
        let unsavedEntity = this._prepareSaveNotification();
        this.store$.dispatch(NotificationsActions.saveNotification({ notification: unsavedEntity }));
    }
    

    close() {
        if (this.notificationsForm.dirty) {
            this.store$.dispatch(NotificationsActions.requestCloseNotificationsDialog());
        } else {
            this.store$.dispatch(NotificationsActions.closeNotificationsDialog());
        }
    }

    deleteNotification() {
        if (this.notifications) {
            this.store$.dispatch(NotificationsActions.deleteNotification({ notification: this.notifications.toDTO() }));
        }
    }

    revert() {
        this.ngOnChanges()
    }
}